import { motion } from "framer-motion";
import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from "@/components/ui/accordion";

const FAQ = () => {
  const faqs = [
    {
      question: "How quickly can you close on my house?",
      answer: "We can typically close in as little as 7-14 days, depending on your situation. However, we're flexible and can work around your timeline if you need more time to move out or make arrangements.",
    },
    {
      question: "Do I need to make repairs before selling?",
      answer: "No! We buy houses in any condition—as-is. Whether your home needs minor updates or major repairs, we'll make you a fair offer without requiring you to fix anything.",
    },
    {
      question: "Are there any fees or commissions?",
      answer: "Absolutely not. We cover all closing costs and there are no realtor commissions or hidden fees. The offer we make is the amount you receive at closing.",
    },
    {
      question: "How do you determine your offer price?",
      answer: "We evaluate your property based on its location, condition, and current market values. Our goal is to make you a fair offer that reflects the true value of your home while accounting for our investment in repairs and resale.",
    },
    {
      question: "What types of properties do you buy?",
      answer: "We buy all types of residential properties including single-family homes, condos, townhouses, duplexes, and multi-family properties. We purchase properties in any condition, anywhere in the country.",
    },
    {
      question: "Is there any obligation if I request an offer?",
      answer: "None at all. Our offers are completely free with no obligation. You can take your time to consider our offer and decide what's best for your situation.",
    },
  ];

  return (
    <section id="faq" className="py-24 md:py-32 bg-white" data-testid="faq-section">
      <div className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Section Header */}
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.5 }}
          className="text-center mb-12"
        >
          <span className="inline-block text-sm font-semibold text-[#D32F2F] uppercase tracking-wide mb-4">
            Common Questions
          </span>
          <h2 
            className="text-3xl md:text-4xl lg:text-5xl font-bold text-slate-900 mb-4"
            style={{ fontFamily: 'Manrope, sans-serif' }}
          >
            Frequently Asked Questions
          </h2>
          <p className="text-lg text-slate-600">
            Have questions? We've got answers. If you don't see your question here, give us a call!
          </p>
        </motion.div>

        {/* Accordion */}
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.5, delay: 0.2 }}
        >
          <Accordion type="single" collapsible className="space-y-4" data-testid="faq-accordion">
            {faqs.map((faq, index) => (
              <AccordionItem
                key={index}
                value={`item-${index}`}
                className="bg-slate-50 rounded-xl border border-slate-100 px-6 data-[state=open]:bg-white data-[state=open]:shadow-md data-[state=open]:border-slate-200 transition-all duration-300"
                data-testid={`faq-item-${index}`}
              >
                <AccordionTrigger 
                  className="text-left font-semibold text-slate-900 hover:text-[#D32F2F] hover:no-underline py-5"
                  style={{ fontFamily: 'Manrope, sans-serif' }}
                >
                  {faq.question}
                </AccordionTrigger>
                <AccordionContent className="text-slate-600 pb-5 leading-relaxed">
                  {faq.answer}
                </AccordionContent>
              </AccordionItem>
            ))}
          </Accordion>
        </motion.div>
      </div>
    </section>
  );
};

export default FAQ;
